import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      // Design-system section 4/5: warm neutral placeholder from the
      // paper/line palette instead of the magenta-tinted accent color.
      className={cn("bg-border animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
